import React from "react";
import { useNavigate } from "react-router-dom";
import BlackLogo from '../../assets/img/black-logo.png';
import EditProfile from '../../assets/img/user2.svg';
// import CallProfile from '../../assets/img/call.svg';
// import SettingProfile from '../../assets/img/settig2.svg';
import AboutProfile from '../../assets/img/about.svg';
import ContactProfile from '../../assets/img/cotact.svg';
// import SupportProfile from '../../assets/img/support.svg';
import ExitProfile from '../../assets/img/exit2.svg';
import { useEffect } from "react";
import { useState } from "react";



const Sidbar = ({ isOpen, toggleSidebar  }) => {


  const navigate = useNavigate();

const base_url_done = "https://app.doneapp.ir/";

  const [namekarbar, setNamekarbar] = useState("");
  const [famili, setFamili] = useState("");
  const [Points, setPoints] = useState("");
  const [Profileimg, setprofileimg] = useState("");
  const [pro, setpro] = useState(null);
  


  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("donetoken");



      try {
        const response = await fetch(`https://app.doneapp.ir/backend/get_user_info.php?token=${token}`);
        const data = await response.json();

        localStorage.setItem("userinfo", JSON.stringify(data.user));

setNamekarbar(data.user.name);
setFamili(data.user.family);
setPoints(data.user.user_points);
setprofileimg(data.user.profile_img);
setpro(Number(data.user.pro_user));





        if (data.status !== "success") {
     
          localStorage.removeItem("userinfo");
          localStorage.removeItem("donetoken"); // توکن نامعتبر است، حذف شود
          navigate("/");
        }
      } catch (error) {
        console.error("Error checking token:", error);
        localStorage.removeItem("donetoken");
        localStorage.removeItem("userinfo");
        localStorage.removeItem("mobile");
        localStorage.removeItem("ref_code");

        navigate("/");
      }
    };

    checkToken();
  }, [navigate]);


const handleLogout = () => {
  localStorage.removeItem("donetoken");
  localStorage.removeItem("userinfo");
  localStorage.removeItem("mobile");
  localStorage.removeItem("ref_code");
  navigate("/");
};




  return (
    <>
   <div className={`overlay ${isOpen ? 'active' : ''}`} onClick={toggleSidebar}></div>
    <nav className={`sidebar ${isOpen ? 'open' : ''}`} id="sidebar">
     

      <div className="sidebar-div-1">
        <img className="sidbar-blacklogo" src={BlackLogo} alt="دان" />
        <img className="profile-img-style" src={`${base_url_done}${Profileimg}`} alt="پروفایل" />

        <span className="sidbar-user-name">
          {namekarbar} {famili}
        </span>

        <div className="sidbar-wallet-div">
          <button className="sidbar-point-btn">
            <span className="sidbar-point-amount-spn">
             {Points}
            </span>
            <span className="sidbar-point-amount-spn"> امتیاز</span>
          </button>

          <button className="sidbar-prouser-btn">
          {pro === 1 ? "کاربر ویژه" : "کاربر عادی"}


            
          </button>

          <hr className="sidbar-hr" />
          <ul className="sidbar-ul-1">
        <li className="sidbar-list-1"
        
        onClick={() => {

          navigate("/panel/profile");
          toggleSidebar();

        }}
        
        >
        <span className="mr-10" >ویرایش مشخصات</span>
            <img src={EditProfile} alt="edit profile" />
        </li>

        {/* <li className="sidbar-list-1" >
        <span className="mr-10" >
        همکاری با دان
          </span>
            <img src={CallProfile} alt="edit profile" />
        </li> */}

        {/* <li className="sidbar-list-1" >
        <span className="mr-10" >
        تنظیمات
          </span>
            <img src={SettingProfile} alt="edit profile" />
        </li> */}

        <li className="sidbar-list-1"
        
          onClick={() => {

          navigate("/panel/about");
          toggleSidebar();

        }}
        
        >
        <span className="mr-10" >
        درباره ما
          </span>
            <img src={AboutProfile} alt="about done" />
        </li>

        <li className="sidbar-list-1"
        
             onClick={() => {

          navigate("/panel/tamasbama");
          toggleSidebar();

        }}
        
        >
        <span className="mr-10" >
        تماس با ما
          </span>
            <img src={ContactProfile} alt="contact us" />
        </li>

        {/* <li className="sidbar-list-1" >
        <span className="mr-10" >
        پشتیبانی نرم افزار
          </span>
            <img src={SupportProfile} alt="support" />
        </li> */}


      </ul>

      <hr className="sidbar-hr" />

      <button className="sidbar-exit-btn"
      
     onClick={handleLogout}
      
      >
            <img src={ExitProfile} alt="edit profile" />
            <span className="sidbar-point-amount-spn">
           خروج از حساب کاربری
            </span>
            
          </button>



        </div>
      </div>


    </nav>
    </>
  );
};

export default Sidbar;
